import { cva } from 'class-variance-authority';

export const cvaRentalPeriod = cva([
  'RentalPeriodStyles-cvaRentalPeriod',
  'flex flex-col gap-0.8',
  'w-full',
  'mt-1.2',
]);

export const cvaRentalPeriodText = cva([
  'RentalPeriodStyles-cvaRentalPeriodText',
  'text-m-sb text-cGray',
]);
